import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FetchPictureService {
    public async fetchPicture(picturePath: string): Promise<string> {
        const response = await fetch(picturePath);

        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = (): void => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
}
